export	const MAIN_BUTTONS = [
    {
        id: "libros",
        name: {
            default: "Libros",
            translationPath: "libros",
        },
        url:"/ayuda/libros",
        icon: "wpf:books"
    },
    {
        id: "plataforma",
        name: {
            default: "Plataforma",
            translationPath: "plataforma",
        },
        url:"/ayuda/plataforma",
        icon: "ri:computer-fill"
    },
    {
        id: "descarga",
        name: {
            default: "Descarga de libros",
            translationPath: "descarga",
        },
        url:"/ayuda/descarga",
        icon: "ep:download"
    },
    {
        id: "apps",
        name: {
            default: "Apps",
            translationPath: "apps",
        },
        url:"/ayuda/apps",
        icon: "material-symbols-light:system-update-rounded"
    },
    /* {
        id: "perfil",
        name: {
            default: "Mi perfil",
            translationPath: "perfil",
        },
        url:"/ayuda/perfil",
        icon: "mingcute:user-2-fill"
    }, */
]